<i18n>
{
	"en": {
		"RequestStatistic": "Todo statistic",
		"InTheLast30Days": "In the last 30 days",
		"Reject": "Reject",
		"Waiting": "Waiting",
		"Done": "Done"
	},
	"vi": {
		"RequestStatistic": "Thống kê đề xuất",
		"InTheLast30Days": "Trong 30 ngày gần nhất",
		"Reject": "Từ chối",
		"Waiting": "Chờ duyệt",
		"Done": "Hoàn tất"
	}
}
</i18n>

<template>
	<div class="list-todo-statistics cbs-custom-table">
		<div class="header flex flex-col md:flex-row justify-between items-center">
			<div class="flex flex-col md:flex-row items-center pt-4 md:pt-0">
				<h4 class="header__title md:py-6 md:pl-6 uppercase">{{ $t("RequestStatistic") }}</h4>
				<p class="ml-0 md:ml-4">{{ $t("InTheLast30Days") }}</p>
			</div>
			<div class="flex flex-row justify-center md:justify-end pr-0 md:pr-6 px-2 md:px-0">
				<div class="ml-2 md:ml-12" v-for="des in statusDescriptions" :key="des.color">
					<span class="statistics-description inline-block mr-1 md:mr-2" :style="{ backgroundColor: des.color }"></span>
					<span class="text-sm md:text-base whitespace-no-wrap">{{ des.name }}</span>
				</div>
			</div>
		</div>

		<div class="grid grid-cols-1 md:grid-cols-2 px-3">
			<RequestByDepartmentStatistics
				v-for="(item, index) in statisticData"
				:key="index"
				class="m-3 mt-3 md:m-3"
				:title="item.department ? item.department.name : ''"
				:data="item.request_types"
			/>
		</div>
	</div>
</template>

<script>
import requestV2GQL from "@/http/requests/request/request_v2_gql.js";

import RequestByDepartmentStatistics from "./RequestByDepartmentStatistics.vue";

export default {
	name: "RequestsStatistics",
	components: {
		RequestByDepartmentStatistics
	},
	data() {
		return {
			statisticData: [],
			statusDescriptions: [
				{ name: this.$t("Reject"), color: "#EB5757" },
				{ name: this.$t("Waiting"), color: "#2B59B2" },
				{ name: this.$t("Done"), color: "#219653" }
			]
		};
	},
	methods: {
		async getStatisticData() {
			try {
				this.$vs.loading();
				const response = (await requestV2GQL.getRequestsStatistic()) || [];
				this.statisticData = response.request_statistic;
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		}
	},
	created() {
		this.getStatisticData();
	}
};
</script>

<style lang="scss" scoped>
.list-todo-statistics {
	.list-todo-statistics__items-container {
		.items-container__item {
			@media screen and (min-width: 1470px) {
				// width: 25% !important;
			}
		}
	}
	.statistics-description {
		width: 12px;
		height: 12px;
		border-radius: 50%;
	}
}
</style>
